 import store from '@/store/index.js';

 const handleError = (error) => {
    if(error.status == '418') {
      store.dispatch('setGenericModalText', 'Zweryfikuj swój adres e-mail aby kontynuować.');
      store.dispatch('setModalType', 'genericModal');
    }
    if(error.status == '401') {
      store.dispatch('setModalType', 'relogModal');
      store.dispatch("toggleLoginModal");
    }
   }
   export default handleError;
